<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <div class="dispatch-table">
          <b-card>
            <div slot="header">
              <span>Transfer Lane</span>
              <a
                href="#"
                class="btn btn-sm btn-info float-right ml-1"
                id="printpagebutton"
                @click="onPrint"
              >
                <i class="fa fa-print"></i> Print
              </a>
              <button
                id="printexport"
                class="btn btn-sm btn-info float-right"
                @click="onexport"
              >
                Export
              </button>
            </div>

            <b-row>
              <b-col md="3" class="my-1">
                <b-form-group label-cols-sm="1" class="mb-0">
                  <b-input-group>
                    <b-form-input
                      v-model="filter"
                      placeholder="Type to Search"
                    />
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''"
                        >Clear</b-button
                      >
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col> </b-row
            >&nbsp;
            <b-table
              show-empty
              bordered
              responsive="sm"
              stacked="md"
              hover
              small
              striped
              head-variant="light"
              :busy.sync="isBusy"
              :items="items"
              :fields="fields"
              :filter="filter"
              :per-page="perPage"
              :current-page="currentPage"
            >
              <template v-slot:cell(Action)="data">
                <b-button
                  size="sm"
                  variant="primary"
                  class="btn btn-primary btn-sm"
                  @click="onSelecteItemToMove(data.item)"
                  >Move</b-button
                >
              </template>
              <template v-slot:cell(checklistdescription)="data">
                <div class="ellipsis">
                  <span>{{ data.item.checklistdescription }}</span>
                </div>
              </template>
              <template v-slot:cell(description)="data">
                <div class="ellipsis">
                  <span>{{ data.item.description }}</span>
                </div>
              </template>
              <template v-slot:cell(arrivaldateti)="data">
                <div>
                  <span>{{
                    data.item.arrivaldatetime
                      | moment("dddd, MMMM Do YYYY, h:mm:ss a")
                  }}</span>
                </div>
              </template>
              <template slot="status" slot-scope="data">
                <i
                  :class="
                    data.item.status == 1
                      ? 'activeStatus icon-check active_icon'
                      : 'inactiveStatus icon-close inactive_icon'
                  "
                ></i>
              </template>
              <template slot="isoccupied" slot-scope="data">
                <i
                  :class="
                    data.item.isoccupied == 1
                      ? 'activeStatus icon-check active_icon'
                      : 'inactiveStatus icon-close inactive_icon'
                  "
                ></i>
              </template>
            </b-table>
          </b-card>
        </div>
        <div>
          <div>
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table"
            >
            </b-pagination>
          </div>
        </div>
        <b-modal
          title="System Message"
          v-model="translaneModal"
          @ok="onTransfer"
        >
          <b-row>
            <b-col md="12">
              <b-form>
                <label class="mr-sm-2" for="inline-form-custom-select-pref"
                  >From</label
                >
                <input
                  type="text"
                  class="form-control bg-white"
                  readonly
                  :value="selectedItemLabel"
                />
              </b-form>
              <small class="text-muted">Lane - Transtype</small>
              <br />
              <b-form>
                <label class="mr-sm-2" for="inline-form-custom-select-pref"
                  >To Loading Lane</label
                >
                <b-form-select v-model="SelectLaneType" class="mb-3">
                  <option
                    v-for="(selectOption, indexOpt) in laneTypes"
                    :key="indexOpt"
                    :value="selectOption"
                  >
                    {{
                      selectOption.laneno +
                      " - " +
                      selectOption.laneDesplay +
                      " - " +
                      selectOption.Transtype
                    }}
                  </option>
                </b-form-select>
              </b-form>
            </b-col>
          </b-row>
        </b-modal>
      </b-col>
      <!-- <pre>{{$data.form|JSON}}</pre> -->
    </b-row>
  </div>
</template>
<script>
import api from "../../../services/api";
import JSONToCSVConvertor from "../../../services/JSONToCSVConvertor";
import miniToastr from "mini-toastr";
import axios from "axios";
import moment from "moment";

export default {
  data: function () {
    return {
      translaneModal: false,
      selectedItem: {},
      selectedItemLabel: "",
      laneTypes: [],
      SelectLaneType: {},
      totalItem: 0,
      perPage: this.$store.getters.perPage,
      currentPage: 1,
      isBusy: false,
      filter: null,
      fields: [
        {
          key: "Action",
        },
        {
          key: "fleetregistryId",
          label: "ID",
          sortable: true,
        },
        {
          key: "parkinglane",
          label: "Laneno",
          sortable: true,
        },
        {
          key: "plateno",
          label: "Plate Number",
          sortable: true,
        },
        {
          key: "licenseno",
          label: "License Number",
          sortable: true,
        },
        {
          key: "lanetype",
          label: "Trans Type",
          sortable: true,
        },
        {
          key: "scancode",
          label: "Barcode",
          sortable: true,
        },
        {
          key: "refdocument",
          label: "Document",
          sortable: true,
        },
        {
          key: "arrivaldatetime",
          label: "ADT",
          sortable: true,
          formatter: "DateConvertFooter",
        },
        {
          key: " remarks",
          label: "Remarks",
          sortable: true,
        },
      ],
      items: [],
      form: {
        fleetregistryId: "",
        brancode: this.$store.getters.selectedWarehouse,
        parkinglane: "",
        regtype: "",
        created_by:
          this.$store.getters.user.firstname +
          " " +
          this.$store.getters.user.lastname,
        create_date: "",
      },
    };
  },

  computed: {
    filter() {
      this.currentPage = 1;
      this.totalrows = this.items.length;
    },

    rows() {
      return this.items.length;
    },
  },

  methods: {
    onPrint: function () {
      // this.isHidden = true;
      var printButton = document.getElementById("printpagebutton");
      var printExport = document.getElementById("printexport");
      var breadView = document.getElementById("breadview");
      //Set the print button visibility to 'hidden'
      printButton.style.visibility = "hidden";
      printExport.style.visibility = "hidden";
      breadView.style.visibility = "hidden";
      //Print the page content
      window.print();
      printButton.style.visibility = "visible";
      printExport.style.visibility = "visible";
      breadView.style.visibility = "visible";
    },

    onexport: function () {
      JSONToCSVConvertor(this.items, "Lane Master", true);
    },

    initTable() {
      // Here we don't set isBusy prop, so busy state will be handled by table itself
      this.isBusy = true;
      let self = this;
      self.$store.commit("setLoading", true);
      axios
        .get(
          this.$store.state.IFMSURLlocal +
            "get-fleet-registry-registry?brancode=" +
            self.$store.state.selectedWarehouse
        )
        .then((resp) => {
          self.items = resp.data;
          console.log("fleet", resp.data);
          // Here we could override the busy state, setting isBusy to false
          self.isBusy = false;
          self.$store.commit("setLoading", false);
        })
        .catch((err) => {
          // Here we could override the busy state, setting isBusy to false
          self.isBusy = false;
          api.httpMsg(self, err.status, err.data);
          self.$store.commit("setLoading", false);

          // Returning an empty array, allows table to correctly handle busy state in case of error
          return [];
        });
    },

    onSelecteItemToMove: function (param) {
      let self = this;
      self.selectedItem = param;
      self.selectedItemLabel =
        self.selectedItem.parkinglane +
        // " - " +
        // self.selectedItem.laneDescription +
        " - " +
        self.selectedItem.lanetype;
      self.form.fleetregistryId = self.selectedItem.fleetregistryId;

      self.$store.commit("setLoading", true);
      api.instance
        .get(
          this.$store.state.IFMSURLlocal +
            "get-select-parkinglane?&laneid=" +
            self.selectedItem.parkinglane +
            "&brancode=" +
            self.$store.state.selectedWarehouse +
            "&transtype=" +
            self.selectedItem.lanetypecode
        )
        .then(function (resp) {
          if (self.selectedItem.parkinglane == resp.data.id) {
          }
          self.laneTypes = resp.data;
          console.log("lane", resp.data);
          self.translaneModal = true;
          self.$store.commit("setLoading", false);
        })
        .catch(function (err) {
          api.httpMsg(self, err.status, err.data);
          self.$store.commit("setLoading", false);
        });
    },

    onTransfer() {
      let self = this;
      self.$store.commit("setLoading", true);

      console.log(self.form);

      axios.post(this.$store.state.IFMSURLlocal + "move-lane", self.form).then(resp => {
        miniToastr.success("Transfer Lane Successful");
        this.initTable();
              self.$store.commit("setLoading", false);

      }).catch(function (err) {
        if(err.response.data == "Please Check Transaction Activity"){
          miniToastr.error(err.response.data)
          
        }else{
          miniToastr.error(err.response.data.InnerException.Message);
        }
        
          self.$store.commit("setLoading", false);
        });

      // api.instance
      //   .put("wfms/move-lane", self.form)
      //   .then(function (resp) {
      //     miniToastr.success("Move complete successfully.");
      //     self.initTable();
      //     self.$store.commit("setLoading", false);
      //   })
      //   .catch(function (err) {
      //     api.httpMsg(self, err.status, err.data);
      //     self.$store.commit("setLoading", false);
      //   });

    },

    DateConvertFooter(date) {
      if (date !== null) {
        var newDate = date;
        newDate =
          newDate[1] + "-" + newDate[2].substring(0, 2) + "-" + newDate[0];
        return moment(date).format("MM-DD-YYYY, h:mm a");
      }
    },
  },

  created: function () {
    this.initTable();
  },

  watch: {
    SelectLaneType(param) {
      let self = this;
      self.form.parkinglane = param.laneno;
      self.form.regtype = param.trantype;
    },
  },
};
</script>